import Requests from "./requests.json"
import Axios from "./axios"

const Api = {
  getUserList() {
    return Axios.get(Requests.USERS, { withCredentials: false })
  },
  getOrderData() {
    return Axios.get(Requests.ORDERS, { withCredentials: false })
  },
  getSingleUserData(userId) {
    return Axios.get(`${Requests.JOB_ORDERS}/${userId}`, {
      withCredentials: false,
    })
  },
  getOrderDetails(orderId) {
    return Axios.get(`${Requests.JOB_ORDERS}/${orderId}`, {
      withCredentials: false,
    })
  },
  getServiceDetails(serviceId) {
    return Axios.get(`${Requests.SERVICE_ID}/${serviceId}`, {
      withCredentials: false,
    })
  },
  getAdminList() {
    return Axios.get(Requests.ADMIN, { withCredentials: false })
  },
  getAdminDetails(adminId) {
    return Axios.get(`${Requests.USERS}/${adminId}`, {
      withCredentials: false,
    })
  },
  getUsersCount() {
    return Axios.get(Requests.USERS_COUNT, { withCredentials: false })
  },
  saveServices({
    partner_type,
    job,
    base_fare,
    additional_fare,
    helper_fare,
    helper_additional_fare,
    known_issues,
  }) {
    return Axios.post(
      Requests.SERVICES,
      {
        partner_type,
        job,
        base_fare,
        additional_fare,
        helper_fare,
        helper_additional_fare,
        known_issues,
      },
      { withCredentials: false }
    )
  },
  updateService({
    partner_type,
    job,
    base_fare,
    additional_fare,
    helper_fare,
    helper_additional_fare,
    known_issues,
    serviceId,
    id,
  }) {
    return Axios.patch(
      `${Requests.SERVICES}/${id}`,
      {
        partner_type,
        job,
        base_fare,
        additional_fare,
        helper_fare,
        helper_additional_fare,
        known_issues,
      },
      { withCredentials: false }
    )
  },
  getServicesList() {
    return Axios.get(Requests.SERVICES, { withCredentials: false })
  },
  getAnalyticsCount() {
    return Axios.get(Requests.ANALYTICS_COUNT, { withCredentials: false })
  },
  getJobsCount() {
    return Axios.get(Requests.JOBS_COUNT, { withCredentials: false })
  },
  getJobsList() {
    return Axios.get(Requests.JOBS, { withCredentials: false })
  },
  getSingleService(id) {
    return Axios.get(Requests.SERVICES + "/" + id, { withCredentials: false })
  },
  getGraphData({ startDate, endDate, isServiceProvider }) {
    if (isServiceProvider) {
      return Axios.get(
        Requests.GRAPH_COUNT +
          `?startDate=${startDate}&endDate=${endDate}&isServiceProvider=${isServiceProvider}`,

        { withCredentials: false }
      )
    } else {
      return Axios.get(
        Requests.GRAPH_COUNT + `?startDate=${startDate}&endDate=${endDate}`,

        { withCredentials: false }
      )
    }
  },
  serachUser(phone) {
    return Axios.get(`${Requests.SEARCH}${phone}`, { withCredentials: false })
  },
}

export default Api
